export const palettes = [
  "yellow-orange",
  "red",
  "red-deep",
  "fuchsia",
  "purple",
  "violet",
  "blue",
  "cyan",
  "green",
  "red-mx",
] as const;
export type Palette = (typeof palettes)[number];
export const isValidPalette = (p: string | undefined | null): p is Palette => {
  if (p == null) return false;
  return palettes.includes(p);
};

export const levels = [
  "light",
  "highlight",
  "true",
  "deep",
  "dark",
  "neutral-dark",
  "neutral-light",
] as const;
export type Level = (typeof levels)[number];
export const isValidLevel = (l: string | undefined | null): l is Level => {
  if (l == null) return false;
  return levels.includes(l);
};

export type UnvalidatedThemeModel =
  | {
      palette?: Palette | string | null;
      background?: Level | string | null;
      foreground?: Level | string | null;
    }
  | null
  | undefined;

export type ThemeModel = {
  palette: Palette;
  background: Level;
  foreground: Level;
};

export const isValidTheme = (
  theme: UnvalidatedThemeModel | null | undefined
): theme is ThemeModel => {
  if (
    !theme ||
    !theme.palette ||
    !theme.background ||
    !theme.foreground ||
    !isValidPalette(theme.palette) ||
    !isValidLevel(theme.background) ||
    !isValidLevel(theme.foreground)
  )
    return false;

  return true;
};
